import React from "react";
import "./styles/teamMemberCard.scss";

interface TeamMemberCardProps {
  name: string;
  role: string;
  photoUrl: string;
  linkedInUrl?: string;
  email: string;
}

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({
  name,
  role,
  photoUrl,
  linkedInUrl,
  email
}) => {
  return (
    <article className="team-card team-member-card">
      <div className="team-card-image-wrap">
        <img
          src={photoUrl}
          alt={`${name}'s profile`}
          className="team-card-photo"
          width={220}
          height={180}
        />
      </div>
      <div className="team-card-info">
        <h3 className="team-card-name">{name}</h3>
        <p className="team-card-role">{role}</p>
        <div className="team-card-actions">
          <div className="team-card-icons">
            {linkedInUrl && (
              <a
                href={linkedInUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin" />
              </a>
            )}
          </div>
          <a href={`mailto:${email}`} className="team-card-cta">
            Contact
          </a>
        </div>
      </div>
    </article>
  );
};

export default TeamMemberCard;
